module.exports = __webpack_public_path__ + "img/flag_es.83e0ceb.png";